// Library Methods
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";
import { useSnackbarContext } from "src/contexts/alerts/SnackbarContext";

// API
import { deletePatients } from "../api";

export const useDeletePatients = (clinicId: string | undefined) => {
  const queryClient = useQueryClient();
  const { getToken } = useTokenAccess();
  const { t } = useTranslation();
  const { setSnackbarInfo } = useSnackbarContext();

  return useMutation({
    mutationFn: async (patientIds: Array<string>) => {
      if (!clinicId) throw new Error();

      try {
        const token = await getToken();
        return deletePatients(token, clinicId, patientIds);
      } catch (error) {
        throw error;
      }
    },
    // Invalidate users query cache
    onSuccess: (_) => {
      queryClient.invalidateQueries({ queryKey: ["patients", clinicId] });
      setSnackbarInfo({
        variant: "success",
        message: t("Patient deleted successfully!"),
      });
    },
    onError: () => {
      setSnackbarInfo({
        variant: "error",
        message: t("Patient could not be deleted!"),
      });
    },
  });
};
